import { GetMostRecentActivityLog } from '@/connection/activity-log/get-activity-log';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectStateReducerCreator } from '../types';

const loadMostRecentActivityLogReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (data: { channel: number; projectUuid: string }, { rejectWithValue }) => {
      try {
        return await GetMostRecentActivityLog(data.channel, data.projectUuid);
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        const mostRecentActivity = action.payload.activities?.[0];

        if (!mostRecentActivity) return;

        state.mostRecentActivityLogUpdate = mostRecentActivity.timestamp;
        state.mostRecentActivityLogType = mostRecentActivity.type;
      },
    }
  );
};

export default loadMostRecentActivityLogReducer;
